/* This abstracts Google Drive components.
   <drive-picker/> and <drive-picker-docs-view/> props at https://www.npmjs.com/package/@googleworkspace/drive-picker-element
   Note: This is defines custom elements and does not export React components.
*/

import {DrivePickerElement,
        DrivePickerDocsViewElement} from "@googleworkspace/drive-picker-element/drive-picker";

// define custom elements
if (customElements.get("drive-picker") === undefined) {
    customElements.define("drive-picker", DrivePickerElement);
}
if (customElements.get("drive-picker-docs-view") === undefined) {
    customElements.define("drive-picker-docs-view", DrivePickerDocsViewElement);
}